import { useMyOrderById } from "api/Client/product";
import { Spinner } from "components";
import { useEffect } from "react";
import {
  HiOutlineCalendarDays,
  HiOutlineCheckCircle,
  HiOutlineClipboardDocumentList,
  HiOutlineClock,
  HiOutlineCube,
  HiOutlineHashtag,
  HiOutlineXCircle,
} from "react-icons/hi2";
import { useNavigate } from "react-router-dom";
import ClientActionModal from "../ClientActionModal/ClientActionModal";

const getOrderStateMeta = (state) => {
  if (state === "pending") {
    return { label: "انتظار", icon: <HiOutlineClock />, color: "text-amber-400" };
  }
  if (state === "approved" || state === "completed") {
    return { label: "مكتملة", icon: <HiOutlineCheckCircle />, color: "text-emerald-400" };
  }
  return { label: "مرفوضة", icon: <HiOutlineXCircle />, color: "text-rose-400" };
};

export default function MyOrderModal({ isOpen, toggle, orderId, url }) {
  const navigate = useNavigate();
  const {
    data: currentOrder,
    isSuccess: currentOrderIsSuccess,
    isFetching: currentOrderIsFetching,
  } = useMyOrderById(orderId);

  useEffect(() => {
    return () => url && navigate("/control-panel/my-orders", { replace: true });
  }, [navigate, url]);

  return (
    <ClientActionModal open={isOpen} close={toggle} size="small" title="تفاصيل عملية الشراء">
      {currentOrderIsFetching ? (
        <div className="portal-page-card mx-auto flex items-center justify-center rounded-[1.35rem] p-6">
          <Spinner sm />
        </div>
      ) : (
        currentOrderIsSuccess && (
          <div className="grid grid-cols-1 gap-3">
            <div className="portal-page-card grid gap-3 rounded-[1.35rem] p-5">
              <div className="flex items-center justify-between gap-3">
                <div
                  className={`flex items-center gap-2 text-sm font-bold ${
                    getOrderStateMeta(currentOrder.data.order_state).color
                  }`}
                >
                  <span className="text-xl">
                    {getOrderStateMeta(currentOrder.data.order_state).icon}
                  </span>
                  {getOrderStateMeta(currentOrder.data.order_state).label}
                </div>
                <h2 className="text-xl font-bold portal-accent" style={{ direction: "ltr" }}>
                  {Number(Math.abs(currentOrder.data.total)).toLocaleString()}{" "}
                  <span className="text-sm">{currentOrder.data.currency}</span>
                </h2>
              </div>

              <InfoRow icon={<HiOutlineClipboardDocumentList className="text-orange-400" />} label="نوع العملية" value="شراء منتج" />
              <InfoRow icon={<HiOutlineHashtag className="text-amber-400" />} label="رقم الطلب" value={currentOrder.data.id} />
              <InfoRow icon={<HiOutlineCube className="text-orange-300" />} label="الخدمة" value={currentOrder.data.service} />
              <InfoRow icon={<HiOutlineCalendarDays className="text-orange-400" />} label="التاريخ" value={currentOrder.data.created_at} ltr />
            </div>

            {!isEmpty(currentOrder.data.field) ? (
              <div className="portal-panel-soft rounded-[1.35rem] p-5">
                <h5 className="mb-4 text-lg font-bold portal-accent">معلومات الطلب</h5>
                <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                  {Object.entries(currentOrder.data.field).map(([key, item]) => (
                    <div className="flex flex-col gap-1" key={key}>
                      <span className="text-sm font-semibold portal-accent">{item.name}</span>
                      <span className="text-lg font-bold" style={{ color: "var(--layout-text)" }}>
                        {item.value}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ) : null}

            {currentOrder.data.reason ? (
              <div className="portal-panel-soft rounded-[1.35rem] p-5">
                <h5 className="mb-4 text-lg font-bold portal-accent">
                  {currentOrder.data.order_state === "rejected" ||
                  currentOrder.data.order_state === "canceled"
                    ? "سبب الرفض"
                    : "الملاحظات"}
                </h5>
                <div
                  className="break-words font-bold leading-7"
                  style={{ color: "var(--layout-text)" }}
                  dangerouslySetInnerHTML={{
                    __html: currentOrder.data.reason?.replace(/\n/g, "<br />"),
                  }}
                />
              </div>
            ) : null}
          </div>
        )
      )}
    </ClientActionModal>
  );
}

function InfoRow({ icon, label, value, ltr = false }) {
  return (
    <div className="flex items-start gap-3" style={{ color: "var(--layout-text-muted)" }}>
      <div className="text-xl">{icon}</div>
      <div className="flex min-w-0 flex-col gap-1">
        <span className="text-xs font-semibold portal-accent">{label}</span>
        <span className="font-bold" style={{ direction: ltr ? "ltr" : "rtl", color: "var(--layout-text)" }}>
          {value}
        </span>
      </div>
    </div>
  );
}

function isEmpty(field) {
  if (field === undefined || field === null) return true;
  if (typeof field === "object") return Object.keys(field).length === 0;
  if (Array.isArray(field)) return field.length === 0;
  return false;
}
